import styled from 'styled-components';

export const AddToHomeScreenMask = styled.div`
  position: fixed;
  inset: 0;
  content: "";
  background: transparent;
  z-index: 10000;
`;
